import {gql} from '@apollo/client'
import {DOCUMENT_VISIVILITIES} from 'consts/document'

export type QueryVariables = {
  id: string
  documentIds: string[]
  per: number
  page: number
}

export type QueryResult = {
  client: {
    id: string
    planType: string
    isVerified: boolean
    employee: Employee
  }
}

export type Employee = {
  id: string
  lastName: string
  firstName: string
  documents: {
    totalCount: number
    list: Document[]
  }
}

export type Document = {
  id: string
  title: string
  visibility: keyof typeof DOCUMENT_VISIVILITIES
  createdAt: string
  createdUser?: CreatedUser
}

export type CreatedUser = {
  id: string
  email: string
  employee: {
    id: string
    displayFirstName: string
    displayLastName: string
  }
}

export const EMPLOYEE_DOCUMENTS = gql`
  query employeeDocuments($id: ID!, $documentIds: [ID!], $per: Int, $page: Int) {
    client {
      id
      planType
      isVerified
      employee(employeeId: $id) {
        id
        lastName
        firstName
        documents(documentIds: $documentIds, per: $per, page: $page) {
          totalCount
          list {
            id
            title
            visibility
            createdAt
            createdUser {
              id
              email
              employee {
                id
                displayFirstName
                displayLastName
              }
            }
          }
        }
      }
    }
  }
`

export const CREATE_EMPLOYEE_DOCUMENT_CONTRACT = gql`
  mutation createEmployeeDocumentContract($input: CreateEmployeeDocumentContractInput!) {
    createEmployeeDocumentContract(input: $input) {
      employeeDocumentContractRequest {
        id
        status
      }
    }
  }
`
